import { render, staticRenderFns } from "./VAnchoredDropdown.vue?vue&type=template&id=8f6e1ad4&"
import script from "./VAnchoredDropdown.vue?vue&type=script&lang=js&"
export * from "./VAnchoredDropdown.vue?vue&type=script&lang=js&"
import style0 from "./VAnchoredDropdown.vue?vue&type=style&index=0&id=8f6e1ad4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports